import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row user-subhead"
}
const _hoisted_2 = { class: "col-md-6 col-sm-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "float-end"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (typeof(_ctx.store.getters.user) !== 'undefined' && typeof(_ctx.store.getters.user.props) !== 'undefined')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-6 col-sm-12" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.route.name !== 'dashboard' && _ctx.route.name !== 'passcode' && _ctx.route.name !== 'PartnerAgreement')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "btn btn-primary px-5 fw-bold",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToDashboard && _ctx.returnToDashboard(...args)))
                }, "Return to Dashboard")
              ]))
            : ((_ctx.store.getters.dashboard_roles.length + _ctx.store.getters.user.props.super_admin) > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.dashboard_roles, (user_role) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: user_role.id,
                      class: _normalizeClass(["btn btn-lg btn-dashboard-nav ms-2", _ctx.store.getters.dashboard_view === user_role.role_id ? 'active' : '']),
                      onClick: ($event: any) => (_ctx.switchDashboard(user_role.role.id))
                    }, _toDisplayString(user_role.role.name), 11, _hoisted_5))
                  }), 128)),
                  (_ctx.store.getters.user.props.super_admin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["btn btn-lg btn-dashboard-nav ms-2", _ctx.store.getters.dashboard_view == _ctx.UserRole.ADMIN ? 'active' : '']),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchDashboard(_ctx.UserRole.ADMIN)))
                      }, "Admin", 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}